export const LOGIN_API_URL = "/api/v2/login"
export const USERS_API_URL = "/api/v2/user"
export const LOGOUT_API_URL = `${USERS_API_URL}/logout`
export const PROFILE_API_URL = `${USERS_API_URL}/me`
export const LINK_ACCOUNT_API_URL = `${USERS_API_URL}/link-account`
export const UNLINK_ACCOUNT_API_URL = `${USERS_API_URL}/link-account/:partner`
export const UPDATE_BROKERAGE_API_URL = `${USERS_API_URL}/link-account/:partner/brokerage`
export const PREPARE_MIGRATION_API_URL = `/api/v2/migrate/prepare`
export const MIGRATION_API_URL = `/api/v2/migrate`
export const REQUEST_PERSONAL_INFORMATION = `${USERS_API_URL}/ccpa/personalinformation/export`
export const GET_FILE_CCPA = `/ccpa/personalinformation/:personalInformationId`
export const GET_CCPA_REQUEST_LIST = `${USERS_API_URL}/ccpa/personalinformation`
export const DELETE_CCPA_FILE = `${USERS_API_URL}/ccpa/personalinformation/:personalInformationId`
export const GET_CONNECTED_PARTNER_URL = `${USERS_API_URL}/link-account`
export const IS_AGREEMENT_ACCEPTED = `/api/v2/agreements/:type/is-accepted`
export const GET_BROKERAGE_BY_PARTNER_AGENT = `/api/v2/user/me/brokerage`
export const ACCEPT_AGREEMENT = `/api/v2/agreements/:type/accept`
export const AGREEMENT_CONTENT = `/api/v2/agreements/:type`
export const GET_SSO_CONFIGS_URL = "/api/v2/sso/config"
export const GET_SSO_CONFIGS_BY_NAME_URL = "/api/v2/sso/config/:name"
export const GET_SUBSCRIPTION_PRODUCT_API_URL = "/api/v2/products"
export const WAITLIST_API_URL = "/v2/crm/waitlists"
export const GET_USER_SUBSCRIPTION_API_URL = "/api/v2/subscriptions"
export const GET_USER_LATEST_SUBSCRIPTION_API_URL =
  "/api/v2/subscriptions/latest"
export const GET_USER_PLAN_API_URL = "/api/v2/subscriptions/users/plans"
export const SELECT_TRIAL_PLAN_API_URL = "/api/v2/subscriptions/trial"
export const AGENT_PROFILE_API_URL = "/api/v3/agent/agent-profile"
export const CREATE_AGENT_PROFILE_PLACEHOLDER_API_URL = `${AGENT_PROFILE_API_URL}/placeholder`
export const GET_USER_SUBSCRIPTION_INVOICE_API_URL =
  "/api/v2/subscriptions/:subscriptionId/invoices"
export const DELETE_PAYMENT_METHOD_API_URL =
  "api/v2/subscriptions/:subscriptionId/payment-methods/:paymentId"
export const CHANGE_PAYMENT_METHOD_API_URL =
  "/api/v2/subscriptions/:subscriptionId/payment-methods"
export const CANCEL_SUBSCRIPTION_API_URL = "/api/v2/subscriptions/cancel"
export const PREVIEW_INVOICE_ENDPOINT =
  "/api/v2/subscriptions/:subscriptionId/invoice/preview"
export const PREVIEW_SUBSCRIPTION_ENDPOINT =
  "/api/v2/subscriptions/:subscriptionId/preview"
export const UPCOMING_INVOICE_ENDPOINT =
  "/api/v2/subscriptions/:subscriptionId/invoice/upcoming"
export const GET_USER_PROPERTIES = "/api/v2/agent/properties"

export const UPDATE_USER_ROLE_FOR_PROPERTY_API_URL =
  "/api/v2/properties/:propertyId/user-role-for-property"

export const SEND_VERIFICATION_EMAIL = "/api/v2/user/me/email/verify"
export const RESET_PASSWORD_API_URL = "/api/v2/user/me/reset-password"

// Auth0 Authentication API
export const REVOKE_REFRESH_TOKEN = "/oauth/revoke"
